export default class Transitioner {
  constructor ({
    $container,
    visibleClass,
    displayValue = 'block',
    hideMode = 'hidden'
  } = {}) {
    this.$container = $container

    this.visibleClass = visibleClass

    this.displayValue = displayValue

    this.hideMode = hideMode
  }

  doElementHide() {
    if (this.hideMode === 'hidden') {
      this.$container.attr('hidden', true)
    } else {
      this.$container.css('display', '')
    }

    this.$container.attr('aria-hidden', true)
  }

  doElementShow() {
    if (this.hideMode === 'hidden') {
      this.$container.removeAttr('hidden')
    } else if (this.hideMode === 'display') {
      this.$container.css('display', this.displayValue)
    }

    this.$container.attr('aria-hidden', false)
  }

  doHide() {
    this.doListenerStart({ hideElement: true })

    this.$container.removeClass(this.visibleClass)
  }

  doListenerStart({
    hideElement = false,
    removeHeight = false
   } = {}) {
    this.doListenerStop()

    this.$container.one('transitionend', (e) => this.handleTransitionEnd({ e, options: {
      hideElement,
      removeHeight
    }}))
  }

  doListenerStop() {
    this.$container.off('transitionend')
  }

  doShow() {
    this.doListenerStop()

    this.doElementShow()

    // Force browser to re-paint the element
    const height = this.$container.outerHeight()

    this.$container.addClass(this.visibleClass)
  }

  doSlideDown() {
    this.doListenerStart({ removeHeight: true })

    this.doElementShow()

    this.$container
      .height(this.$container.prop('scrollHeight'))
      .addClass(this.visibleClass)
  }

  doSlideUp() {
    this.doListenerStart({ hideElement: true, removeHeight: true })

    this.$container
      .height(this.$container.prop('scrollHeight'))
      .removeClass(this.visibleClass)
      .height(0)
  }

  handleTransitionEnd({ e, options }) {
    if (options.hideElement) {
      this.doElementHide()
    }

    if (options.removeHeight) {
      this.$container.css('height', '');
    }
  }
}
